var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlide5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1200,
    height: 628,
    viewBox: "0 0 1200 628",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_7)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 628,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200 0H0V628H1200V0Z",
    fill: "#A6EEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M872 197.8C848.1 197.8 825.1 201.1 803.2 207.3C746.9 134.8 659 88.2 560.1 88.2C413.5 88.2 290.9 190.8 260.1 328C256.1 327.2 251.9 326.7 247.6 326.7C214.1 326.7 187 353.8 187 387.3C187 391.5 187.4 395.5 188.2 399.4C121.7 416.5 72.5 477 72.5 548.9C72.5 577.8 80.5 604.9 94.3 628H1051.9C1096.9 582.4 1124.7 519.7 1124.7 450.5C1124.7 310.9 1011.6 197.8 872 197.8Z",
    fill: "#44B4B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.4 435.6C379.4 435.6 331.3 473.8 316.4 526H556.3C541.4 473.8 493.4 435.6 436.4 435.6Z",
    fill: "#2F7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M763.6 435.6C706.6 435.6 658.5 473.8 643.6 526H883.5C868.7 473.8 820.6 435.6 763.6 435.6Z",
    fill: "#2F7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.7 396.9C526.3 396.9 457.6 451.5 436.3 526.1H779C757.8 451.5 689.1 396.9 607.7 396.9Z",
    fill: "#2F7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.1 88.8C79.3 88.8 50.8 111.5 42 142.4H184.2C175.3 111.4 146.8 88.8 113.1 88.8Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307 88.8C273.2 88.8 244.7 111.5 235.9 142.4H378.1C369.3 111.4 340.8 88.8 307 88.8Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.6 65.8C166.4 65.8 125.7 98.2001 113.1 142.3H316.2C303.5 98.2001 262.8 65.8 214.6 65.8Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.6 92.9C890.3 92.9 866.4 111.9 859 137.8H978.2C970.7 111.9 946.9 92.9 918.6 92.9Z",
    fill: "#7DE3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1081.1 92.9C1052.8 92.9 1028.9 111.9 1021.5 137.8H1140.7C1133.3 111.9 1109.4 92.9 1081.1 92.9Z",
    fill: "#7DE3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1003.7 73.6C963.3 73.6 929.2 100.7 918.6 137.8H1088.8C1078.2 100.8 1044.1 73.6 1003.7 73.6Z",
    fill: "#7DE3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.4 557.7H320.6C310.3 557.7 301.9 549.3 301.9 539C301.9 528.7 310.3 520.3 320.6 520.3H879.3C889.6 520.3 898 528.7 898 539C898.1 549.4 889.7 557.7 879.4 557.7Z",
    fill: "#006184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M925 125.9C906 125.9 890 138.6 885.1 156H964.9C959.9 138.6 943.9 125.9 925 125.9Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033.9 125.9C1014.9 125.9 998.9 138.6 994 156H1073.8C1068.8 138.6 1052.9 125.9 1033.9 125.9Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982 113C954.9 113 932.1 131.2 925 156H1039C1031.9 131.2 1009.1 113 982 113Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.3 136.5C105.3 136.5 89.2999 149.2 84.3999 166.6H164.2C159.3 149.3 143.3 136.5 124.3 136.5Z",
    fill: "#7DE3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.2 136.5C214.2 136.5 198.2 149.2 193.3 166.6H273.1C268.2 149.3 252.2 136.5 233.2 136.5Z",
    fill: "#7DE3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.3 123.6C154.2 123.6 131.4 141.8 124.3 166.6H238.3C231.3 141.8 208.4 123.6 181.3 123.6Z",
    fill: "#7DE3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.3 539.3V416.9",
    stroke: "#006184",
    strokeWidth: 10,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.2 491L359.8 479.9",
    stroke: "#006184",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.9 341.4C295.9 351.7 300.1 361 306.8 367.8C289.6 377.2 278 395.4 278 416.4C278 447 302.8 471.7 333.3 471.7V304C312.6 304 295.9 320.7 295.9 341.4Z",
    fill: "#369094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.8 367.8C366.5 361 370.7 351.7 370.7 341.4C370.7 320.7 354 304 333.3 304V471.7C363.9 471.7 388.6 446.9 388.6 416.4C388.6 395.4 377 377.2 359.8 367.8Z",
    fill: "#2F7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.5 544.5V422.1",
    stroke: "#006184",
    strokeWidth: 10,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.5 509.5V387.1",
    stroke: "#006184",
    strokeWidth: 10,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.2 489.5C782.1 489.5 758.3 508.4 751 534.2H869.5C862.1 508.4 838.3 489.5 810.2 489.5Z",
    fill: "#2F7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971.8 489.5C943.7 489.5 919.9 508.4 912.6 534.2H1031C1023.7 508.4 1000 489.5 971.8 489.5Z",
    fill: "#2F7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.8 470.3C854.6 470.3 820.7 497.3 810.2 534.1H979.4C968.9 497.3 935 470.3 894.8 470.3Z",
    fill: "#2F7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156 396.5C156 405.2 159.5 413 165.2 418.7C150.8 426.6 141 441.9 141 459.5C141 485.2 161.8 506 187.5 506V365C170.1 365 156 379.1 156 396.5Z",
    fill: "#369094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.7 418.6C215.4 412.9 218.9 405.1 218.9 396.4C218.9 379 204.8 365 187.5 365V505.9C213.2 505.9 234 485.1 234 459.4C233.9 441.8 224.2 426.5 209.7 418.6Z",
    fill: "#2F7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M919 361.5C919 370.2 922.5 378 928.2 383.7C913.8 391.6 904 406.9 904 424.5C904 450.2 924.8 471 950.5 471V330C933.1 330 919 344.1 919 361.5Z",
    fill: "#369094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M972.7 383.6C978.4 377.9 981.9 370.1 981.9 361.4C981.9 344 967.8 330 950.5 330V470.9C976.2 470.9 997 450.1 997 424.4C996.9 406.8 987.2 391.5 972.7 383.6Z",
    fill: "#2F7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.5 484.9C710.5 484.8 710.5 484.6 710.5 484.5C710.4 483.5 709.4 482.7 708.4 482.9L695 484.5C694 484.6 693.2 485.6 693.4 486.6C693.5 487.6 694.5 488.4 695.5 488.2L708.9 486.6C709.8 486.5 710.4 485.7 710.5 484.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.8 482.7C706.8 482.7 710.9 479.9 711.4 481C711.9 482 718.3 497.5 717.6 497.9C715.2 499.1 708.2 487.2 707.9 485.9C707.7 484.4 706.2 483.1 706.8 482.7Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.3 383.7C593.3 383.7 587.2 376.2 584.8 376.2C582.4 376.2 587.3 384 592.8 386L593.3 383.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.5 383.1C592.2 384.1 591 385.1 589.9 386.1C607.6 407 626.8 413.1 644.2 388.7C646.8 385 645.7 384.7 642.9 383.2C643.1 382.5 643.1 382.5 642.9 383.2C640.1 381.7 639.4 382.3 637.3 385.4C623.2 405.8 608.4 398.3 593.5 383.1Z",
    fill: "#A6EEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637.8 545.4C637.9 545.4 638 545.4 638.2 545.4C639.2 545.2 639.9 544.2 639.7 543.2L637 530C636.8 529 635.8 528.3 634.8 528.5C633.8 528.7 633.1 529.7 633.3 530.7L636 543.9C636.2 544.8 637 545.4 637.8 545.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626 489.3C627.6 508.9 630.3 528.2 631.7 542C633.7 542 635.7 541.8 637.7 541.5C664.3 530.2 693.6 506.3 701.6 481.8C698.9 480.7 695.8 480.9 693.3 482.5C682.1 489.7 638.4 481.5 649.5 428.7C647.3 428.1 645.1 427.6 643 427C639.8 426.2 636.6 425.4 633.4 424.7C633.3 425.6 633.2 426.6 633.2 427.5C632.3 427.1 631.4 426.7 630.6 426.3C624 441.4 624.1 465.5 626 489.3Z",
    fill: "#003057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.2 366.9C640.1 362.3 642.2 356.3 646.4 354.2C650.6 352 655.7 354.9 657.9 359.1C660.1 363.3 657.1 372.7 652.9 374.8C648.7 377 642.5 372.7 641.2 366.9Z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647 367C647 372.7 643.1 377.3 639.6 377.3C636.1 377.3 634.5 372.7 634.5 367C634.5 361.3 637.3 358.4 640.8 358.4C644.2 358.4 647 361.3 647 367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.5 368.9C649.5 370.2 648.2 371.9 647.2 371.9C646.2 371.9 646 370.8 646 369.5C646 368.2 646.8 366.9 647.7 366.9C648.8 367 649.5 367.6 649.5 368.9Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.8 363.4C647.8 363.4 646.6 359.8 643.8 358.5C641 357.2 635.5 357.4 634.3 362.4C634.3 362.4 633.8 366 638.2 366.3C642.7 366.5 641.7 364.3 644 366.3C646.3 368.3 648.1 366.6 648.6 367L647.8 363.4Z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627 439C630.5 439.1 635.1 438.3 639.4 436.2C640.6 435.6 641.9 435.1 643.2 434.8C645.4 434.2 647.7 433.9 649.7 433.8C650.5 422.5 652.4 392.6 650.6 387C650.2 385.8 649.7 384.6 649.2 383.6C648.9 382.9 648.5 382.3 648.2 381.7C646.3 378.6 644.4 377.2 644.4 377.2C644.4 377.2 641.9 379.4 640 379.2C639 379.1 637.8 381.1 636.6 383.6C635.9 385 635.2 386.5 634.4 387.9C634.1 388.5 633.7 389.1 633.4 389.6C632.4 391.1 631.6 392.2 630.9 393.4C629.8 395.4 629.5 397.4 630.9 401.4C631.7 404.2 626.6 435.1 627 439Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.7 370L640.8 369.4C640.7 370.2 640.1 377.9 640.4 380.9C640.6 381.8 642.1 382.2 643.7 381.8C645.1 381.4 646.2 380.6 646.2 379.7C646.1 378 646.5 372.9 646.7 370Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.2 542.9C640.2 542.9 641.4 547.7 640.2 547.9C639 548 622.3 548.5 622.2 547.8C621.9 545.2 635.5 542.7 636.9 543C638.2 543.1 640 542.2 640.2 542.9Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.4 402.6C690.4 402.6 697.8 395.7 700.3 396C702.8 396.4 696.5 403.8 690.5 405.1L690.4 402.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.1 401.6C691.8 402.9 692.6 404.4 693.4 405.6C669.8 418.5 652 421.9 643.9 392.4C642.7 387.9 644.7 388.6 646.5 387C649.8 387.3 650.6 386.6 651.5 390.8C657.3 418.5 670.4 409 691.1 401.6Z",
    fill: "#A6EEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.6 177.9V163.1H432.6V264.8C434.5 264.7 436.5 264.6 438.4 264.6C475.9 264.6 507 285.1 512.2 311.9H530L553.7 370.6L577.4 311.9H674.8V209.8H646.6C628.9 209.8 614.6 195.5 614.6 177.9Z",
    fill: "#7DE3F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.6 264.8C423.6 265.3 415.1 267 407.3 269.7C391.4 259.3 370.5 253 347.6 253C324.7 253 303.8 259.3 287.9 269.7C278.4 266.5 267.9 264.7 256.8 264.7C215.6 264.7 182.3 289.4 182.3 319.8C182.3 350.3 215.7 374.9 256.8 374.9C267.9 374.9 278.4 373.1 287.9 369.9C303.8 380.3 324.7 386.6 347.6 386.6C364.6 386.6 380.6 383.1 394.2 377L434.7 415.1L425.2 374C429.5 374.6 433.9 374.9 438.4 374.9C479.6 374.9 512.9 350.2 512.9 319.8C512.9 317.1 512.6 314.5 512.1 311.9H432.5V264.8H432.6Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.4 264.6C436.4 264.6 434.5 264.7 432.6 264.8V311.9H512.2C507 285.2 476 264.6 438.4 264.6Z",
    fill: "#FF7975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M812.3 74.9H646.5C628.9 74.9 614.6 89.2 614.6 106.8V163.1H674.7V209.8H706.8L705.1 257.3L739.3 209.8H812.3C829.9 209.8 844.2 195.5 844.2 177.9V106.8C844.2 89.2 829.9 74.9 812.3 74.9Z",
    fill: "#FC4E6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.6 163.1V177.9C614.6 195.5 628.9 209.8 646.5 209.8H674.7V163.1H614.6Z",
    fill: "#FF7975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.4 543.2C529.5 543.2 529.7 543.2 529.8 543.2C530.9 543.1 531.8 542.1 531.7 540.9L530.3 526C530.2 524.9 529.2 524 528 524.1C526.9 524.2 526 525.2 526.1 526.4L527.5 541.3C527.6 542.3 528.4 543.1 529.4 543.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.6 541.8C533.6 541.8 535.1 547.1 533.8 547.3C532.5 547.5 514 548.7 513.9 547.8C513.4 544.9 528.5 541.7 530 541.9C531.5 542.2 533.5 541 533.6 541.8Z",
    fill: "#3FCDE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.3 365.3C570.3 365.3 570.6 354.6 572.8 353C575 351.4 575.8 361.6 572.3 367.1L570.3 365.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.7 363.9C570.4 364.5 572 365.2 573.7 365.8C560.1 396.8 544.9 388.3 524.4 370.9C521.3 368.2 522.6 366.7 525.4 364.7C525.1 364.1 525.1 364.1 525.4 364.7C528.2 362.8 529.4 363.7 532.1 366.4C550 383.5 554.2 387.5 568.7 363.9Z",
    fill: "#A6EEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.8 532.3C540.7 532.2 540.6 532.1 540.5 532C539.7 531.2 539.7 529.9 540.5 529.1L551.1 518.6C551.9 517.8 553.2 517.8 554 518.6C554.8 519.4 554.8 520.7 554 521.5L543.4 532C542.7 532.8 541.6 532.8 540.8 532.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.1 528.1C547.3 526.6 545.5 525 543.8 523.3C581.1 476.9 582.1 455.2 525.6 426.3C528.3 420.7 531.1 415.2 534.1 409.7C590.8 447.5 588.5 477.7 549.1 528.1Z",
    fill: "#003057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.3 535.8C527.6 535.7 529.9 535.6 532.2 535.3C524.2 500 525 447.8 536.9 412.9C531.2 411.1 525.4 409.4 519.6 407.8C512.7 443.9 519.7 500.1 525.3 535.8Z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.2 528.6C540.2 528.6 536.2 532.3 537.1 533.2C538 534.1 553.2 544.8 553.8 544.1C555.7 541.9 544.6 531.2 543.2 530.6C541.9 530 540.8 528 540.2 528.6Z",
    fill: "#3FCDE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.9 422.3C521.8 421.2 525.9 420.1 533.2 419.8C538.1 419.6 542 419.8 545 420.2C532.3 393 530.1 379.5 531.3 371.8C531.9 368 530.4 364.2 527.3 361.8L526.1 360.9C520.6 356.7 512.5 359.7 511.1 366.5C510.7 368.8 510.3 371.4 510.2 374.4C509.5 388.4 511.4 403.7 518.9 422.3Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.1 349.8C518.6 355.9 524.8 359.1 528.5 357.6C532.2 356.1 532 350.4 529.5 344.4C527 338.3 522.8 336.5 519 338C515.4 339.4 513.6 343.7 516.1 349.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.1 350L524 349.3C524.1 350.2 524.8 359.2 524.5 362.6C524.2 363.6 522.5 364.1 520.7 363.7C519 363.3 517.8 362.3 517.8 361.3C517.9 359.3 517.5 353.3 517.1 350Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.9 351.1C529.2 351 528.5 350.9 527.9 351.3C527.7 351.4 527.5 351.6 527.3 351.7C527.1 351.8 527 351.8 526.8 351.9C526.5 352.1 526.2 352.4 526 352.6C525.7 353 524.8 354.2 525.8 354.4C526 354.4 526.3 354.4 526.5 354.3C527.2 354 527.6 353.2 528.3 352.9C528.4 352.8 528.6 352.8 528.7 352.7C529.1 352.5 529.5 352.4 530 352.3C530.2 352.2 530.4 352.2 530.6 352.1C530.8 352 530.9 351.8 530.9 351.6C530.7 351.3 530.3 351.2 529.9 351.1Z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.7 339.3C527.6 339.1 527.4 338.9 527.2 338.7C527.5 338.3 527.7 337.7 527.5 337.3C527.2 336.7 526.5 336.6 525.8 336.6C525.8 336 525.8 335.4 525.6 334.9C525.4 334.4 524.8 334 524.3 334C523.7 334 523.4 334.2 523 333.8C522.7 333.6 522.6 333.1 522.3 332.9C521.9 332.6 521.4 333.1 521.3 333.5C521.2 333.9 521.2 334.4 521 334.9C520.8 335.2 520.5 335.5 520.2 335.7C519.8 336.1 519.5 336.5 519.3 337C517.9 337.5 516.6 338.4 515.8 339.3C515.2 339.9 514.8 340.7 514.5 341.4C514.4 341.5 514.4 341.5 514.3 341.5C514.1 341.6 513.9 341.6 513.7 341.6C512.8 341.8 512.2 342.6 512 343.5C511.8 344.4 512.1 345.3 512.5 346.1C512.7 346.5 513 347 512.9 347.4C512.9 347.6 512.8 347.8 512.7 348C512.5 348.6 512.5 349.2 512.7 349.8C513 350.3 513.6 350.7 514.2 350.7C514.4 350.7 514.6 350.6 514.8 350.5C515.1 350.4 515.6 350.3 516 350.1C516.9 349.9 518.1 349.4 518.9 347.8C520.5 344.6 520.5 347.5 525.1 345.3C529.8 343 527.7 339.3 527.7 339.3Z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.2 352.5C514.8 353.9 516.9 355.2 517.9 354.7C518.9 354.3 518.7 353 518.1 351.6C517.5 350.2 516.2 349.2 515.1 349.6C514 350 513.6 351.1 514.2 352.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.6 352.8C518.6 352.8 517.7 352.6 518.4 353.8C519.1 355 523.3 358.9 527.6 358.7C531.9 358.4 532 354.3 531.9 353.5C531.8 352.7 531.4 352.3 530.8 354.1C530.2 356 528.4 357.4 526.4 357.2C524.4 357 521 355.1 520.1 354.3C519.1 353.6 518.6 352.8 518.6 352.8Z",
    fill: "#1A1C2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.2 414.1C507.2 414.1 517.2 419.3 517.7 422.1C518.2 424.9 508.2 421 504.6 415.2L507.2 414.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.7 414.7C508.5 416 507.3 417.3 506.2 418.5C485 398.6 477.2 377.4 508.5 364.6C513.3 362.6 513 364.1 514.2 366.9C514.7 367.1 514.9 367.3 514.2 366.9C515.5 369.7 515.9 371.4 511.4 372.9C481.9 382.3 496.2 396.6 509.7 414.7Z",
    fill: "#A6EEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.1 522.9C232 522.9 220.2 532.3 216.5 545.2H275.7C272 532.3 260.2 522.9 246.1 522.9Z",
    fill: "#2F7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.6 513.3C187.5 513.3 170.5 526.8 165.3 545.2H249.9C244.7 526.8 227.7 513.3 207.6 513.3Z",
    fill: "#2F7D80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.7 150.8C516.7 116.7 474.2 89 421.8 89C369.4 89 327 116.7 327 150.8C327 183.2 365.2 209.7 413.8 212.4C416.6 228.2 422 253 422 253L428.5 212.4C477.8 210.2 516.7 183.5 516.7 150.8Z",
    fill: "#003057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.3 144.3C382.553 144.3 386 140.853 386 136.6C386 132.347 382.553 128.9 378.3 128.9C374.047 128.9 370.6 132.347 370.6 136.6C370.6 140.853 374.047 144.3 378.3 144.3Z",
    fill: "#006184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.3 144.3C411.553 144.3 415 140.853 415 136.6C415 132.347 411.553 128.9 407.3 128.9C403.047 128.9 399.6 132.347 399.6 136.6C399.6 140.853 403.047 144.3 407.3 144.3Z",
    fill: "#006184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.3 144.3C440.553 144.3 444 140.853 444 136.6C444 132.347 440.553 128.9 436.3 128.9C432.047 128.9 428.6 132.347 428.6 136.6C428.6 140.853 432.047 144.3 436.3 144.3Z",
    fill: "#006184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.3 144.3C469.553 144.3 473 140.853 473 136.6C473 132.347 469.553 128.9 465.3 128.9C461.047 128.9 457.6 132.347 457.6 136.6C457.6 140.853 461.047 144.3 465.3 144.3Z",
    fill: "#006184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.3 172.6C382.553 172.6 386 169.153 386 164.9C386 160.647 382.553 157.2 378.3 157.2C374.047 157.2 370.6 160.647 370.6 164.9C370.6 169.153 374.047 172.6 378.3 172.6Z",
    fill: "#006184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.3 172.6C411.553 172.6 415 169.153 415 164.9C415 160.647 411.553 157.2 407.3 157.2C403.047 157.2 399.6 160.647 399.6 164.9C399.6 169.153 403.047 172.6 407.3 172.6Z",
    fill: "#006184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.3 172.6C440.553 172.6 444 169.153 444 164.9C444 160.647 440.553 157.2 436.3 157.2C432.047 157.2 428.6 160.647 428.6 164.9C428.6 169.153 432.047 172.6 436.3 172.6Z",
    fill: "#006184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.3 172.6C469.553 172.6 473 169.153 473 164.9C473 160.647 469.553 157.2 465.3 157.2C461.047 157.2 457.6 160.647 457.6 164.9C457.6 169.153 461.047 172.6 465.3 172.6Z",
    fill: "#006184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.2 104H647V115.3H810.2V104Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.2 124.4H647V135.7H810.2V124.4Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.2 144.7H647V156H810.2V144.7Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.2 165.2H688V176.5H810.2V165.2Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1 297.4H266.1C264.3 297.4 262.9 296 262.9 294.2C262.9 292.4 264.3 291 266.1 291H409.1C410.9 291 412.3 292.4 412.3 294.2C412.3 295.9 410.9 297.4 409.1 297.4Z",
    fill: "#FF7975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.1 311.9H217.6C215.8 311.9 214.4 310.5 214.4 308.7C214.4 306.9 215.8 305.5 217.6 305.5H418.1C419.9 305.5 421.3 306.9 421.3 308.7C421.3 310.4 419.9 311.9 418.1 311.9Z",
    fill: "#FF7975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486 326.4H217.6C215.8 326.4 214.4 325 214.4 323.2C214.4 321.4 215.8 320 217.6 320H486C487.8 320 489.2 321.4 489.2 323.2C489.2 325 487.8 326.4 486 326.4Z",
    fill: "#FF7975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.1 340.9H266.1C264.3 340.9 262.9 339.5 262.9 337.7C262.9 335.9 264.3 334.5 266.1 334.5H409.1C410.9 334.5 412.3 335.9 412.3 337.7C412.3 339.5 410.9 340.9 409.1 340.9Z",
    fill: "#FF7975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.4 81.7C561.4 78 557.8 76 553.3 76C548.1 76 543.3 79.1 540.8 84.2L519.4 73.5C525.5 62 537.7 54 557 54C575.9 54 590 62 590 77C590 95.4 570.7 98.7 570.7 108H545.9C545.9 93.4 561.4 89.1 561.4 81.7ZM542.4 127C542.4 118.9 548.9 112.8 558.3 112.8C567.7 112.8 574.2 118.9 574.2 127C574.2 135 567.7 141.5 558.3 141.5C548.9 141.5 542.4 135 542.4 127Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M968.6 285.3C968.6 283.2 966.6 282.2 964.2 282.2C961.4 282.2 958.7 283.9 957.3 286.7L945.5 280.8C948.9 274.4 955.6 270.1 966.1 270.1C976.5 270.1 984.2 274.5 984.2 282.7C984.2 292.8 973.6 294.6 973.6 299.7H960C960.1 291.8 968.6 289.4 968.6 285.3ZM958.1 310.2C958.1 305.8 961.7 302.4 966.8 302.4C972 302.4 975.5 305.8 975.5 310.2C975.5 314.6 971.9 318.1 966.8 318.1C961.7 318.2 958.1 314.6 958.1 310.2Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.5 408.4H783.7L779.2 451.9H761.1L756.5 408.4ZM756.8 467.8C756.8 461.1 762.2 455.9 770.1 455.9C778 455.9 783.4 461 783.4 467.8C783.4 474.4 778 479.9 770.1 479.9C762.3 479.9 756.8 474.5 756.8 467.8Z",
    fill: "#FF7975"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.5 225.4H662.7L658.2 268.9H640.1L635.5 225.4ZM635.8 284.8C635.8 278.1 641.2 272.9 649.1 272.9C657 272.9 662.4 278 662.4 284.8C662.4 291.4 657 296.9 649.1 296.9C641.3 296.9 635.8 291.5 635.8 284.8Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M994.4 291.8H1021.6L1017.1 335.3H999L994.4 291.8ZM994.7 351.3C994.7 344.6 1000.1 339.4 1008 339.4C1015.9 339.4 1021.3 344.5 1021.3 351.3C1021.3 357.9 1015.9 363.4 1008 363.4C1000.1 363.4 994.7 357.9 994.7 351.3Z",
    fill: "#E83857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.5 396.3H471.7L468.7 425.4H456.6L453.5 396.3ZM453.7 436.1C453.7 431.6 457.3 428.1 462.6 428.1C467.9 428.1 471.5 431.5 471.5 436.1C471.5 440.6 467.9 444.2 462.6 444.2C457.4 444.2 453.7 440.5 453.7 436.1Z",
    fill: "#003057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.5 230.2C875.5 223.4 880.5 218.9 887.2 218.9C893.8 218.9 898.9 223.4 898.9 230.2C898.9 236.9 893.9 241.7 887.2 241.7C880.5 241.6 875.5 236.9 875.5 230.2Z",
    fill: "#003057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.3 230.2C902.3 223.4 907.3 218.9 914 218.9C920.6 218.9 925.7 223.4 925.7 230.2C925.7 236.9 920.7 241.7 914 241.7C907.4 241.6 902.3 236.9 902.3 230.2Z",
    fill: "#003057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.2 230.2C929.2 223.4 934.2 218.9 940.9 218.9C947.5 218.9 952.6 223.4 952.6 230.2C952.6 236.9 947.6 241.7 940.9 241.7C934.2 241.6 929.2 236.9 929.2 230.2Z",
    fill: "#003057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.5 51.2C440.5 44.4 445.5 39.9 452.2 39.9C458.8 39.9 463.9 44.4 463.9 51.2C463.9 57.9 458.9 62.7 452.2 62.7C445.5 62.6 440.5 57.9 440.5 51.2Z",
    fill: "#44B4B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.3 51.2C467.3 44.4 472.3 39.9 479 39.9C485.6 39.9 490.7 44.4 490.7 51.2C490.7 57.9 485.7 62.7 479 62.7C472.4 62.6 467.3 57.9 467.3 51.2Z",
    fill: "#44B4B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.2 51.2C494.2 44.4 499.2 39.9 505.9 39.9C512.5 39.9 517.6 44.4 517.6 51.2C517.6 57.9 512.6 62.7 505.9 62.7C499.2 62.6 494.2 57.9 494.2 51.2Z",
    fill: "#44B4B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.5 234.2C176.5 227.4 181.5 222.9 188.2 222.9C194.8 222.9 199.9 227.4 199.9 234.2C199.9 240.9 194.9 245.7 188.2 245.7C181.5 245.6 176.5 240.9 176.5 234.2Z",
    fill: "#44B4B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.3 234.2C203.3 227.4 208.3 222.9 215 222.9C221.7 222.9 226.7 227.4 226.7 234.2C226.7 240.9 221.7 245.7 215 245.7C208.3 245.7 203.3 240.9 203.3 234.2Z",
    fill: "#44B4B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.2 234.2C230.2 227.4 235.2 222.9 241.9 222.9C248.6 222.9 253.6 227.4 253.6 234.2C253.6 240.9 248.6 245.7 241.9 245.7C235.2 245.7 230.2 240.9 230.2 234.2Z",
    fill: "#44B4B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.5 421.2C1024.5 414.4 1029.5 409.9 1036.2 409.9C1042.9 409.9 1047.9 414.4 1047.9 421.2C1047.9 427.9 1042.9 432.7 1036.2 432.7C1029.5 432.7 1024.5 427.9 1024.5 421.2Z",
    fill: "#3B9DA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1051.3 421.2C1051.3 414.4 1056.3 409.9 1063 409.9C1069.7 409.9 1074.7 414.4 1074.7 421.2C1074.7 427.9 1069.7 432.7 1063 432.7C1056.3 432.7 1051.3 427.9 1051.3 421.2Z",
    fill: "#3B9DA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1078.2 421.2C1078.2 414.4 1083.2 409.9 1089.9 409.9C1096.6 409.9 1101.6 414.4 1101.6 421.2C1101.6 427.9 1096.6 432.7 1089.9 432.7C1083.2 432.7 1078.2 427.9 1078.2 421.2Z",
    fill: "#3B9DA1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M989 463.8C989 454.4 996 448.2 1005.1 448.2C1014.3 448.2 1021.2 454.4 1021.2 463.8C1021.2 473.1 1014.2 479.7 1005.1 479.7C995.9 479.7 989 473.1 989 463.8Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1026.1 463.8C1026.1 454.4 1033.1 448.2 1042.2 448.2C1051.4 448.2 1058.3 454.4 1058.3 463.8C1058.3 473.1 1051.3 479.7 1042.2 479.7C1033 479.7 1026.1 473.1 1026.1 463.8Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1063.2 463.8C1063.2 454.4 1070.2 448.2 1079.3 448.2C1088.4 448.2 1095.4 454.4 1095.4 463.8C1095.4 473.1 1088.4 479.7 1079.3 479.7C1070.2 479.7 1063.2 473.1 1063.2 463.8Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379 482.8C379 473.4 386 467.2 395.1 467.2C404.3 467.2 411.2 473.4 411.2 482.8C411.2 492.1 404.2 498.7 395.1 498.7C385.9 498.7 379 492.1 379 482.8Z",
    fill: "#A6EEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.1 482.8C416.1 473.4 423.1 467.2 432.2 467.2C441.4 467.2 448.3 473.4 448.3 482.8C448.3 492.1 441.3 498.7 432.2 498.7C423 498.7 416.1 492.1 416.1 482.8Z",
    fill: "#A6EEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.2 482.8C453.2 473.4 460.2 467.2 469.3 467.2C478.5 467.2 485.4 473.4 485.4 482.8C485.4 492.1 478.4 498.7 469.3 498.7C460.1 498.7 453.2 492.1 453.2 482.8Z",
    fill: "#A6EEFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.5 230.1C334.5 224.3 338.8 220.5 344.4 220.5C350 220.5 354.3 224.3 354.3 230.1C354.3 235.8 350 239.9 344.4 239.9C338.7 239.8 334.5 235.8 334.5 230.1Z",
    fill: "#003057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.3 230.1C357.3 224.3 361.6 220.5 367.2 220.5C372.8 220.5 377.1 224.3 377.1 230.1C377.1 235.8 372.8 239.9 367.2 239.9C361.5 239.8 357.3 235.8 357.3 230.1Z",
    fill: "#003057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.1 230.1C380.1 224.3 384.4 220.5 390 220.5C395.6 220.5 399.9 224.3 399.9 230.1C399.9 235.8 395.6 239.9 390 239.9C384.3 239.8 380.1 235.8 380.1 230.1Z",
    fill: "#003057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.1 394.7C209.1 388.9 213.4 385.1 219 385.1C224.6 385.1 228.9 388.9 228.9 394.7C228.9 400.4 224.6 404.5 219 404.5C213.4 404.5 209.1 400.4 209.1 394.7Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.9 394.7C231.9 388.9 236.2 385.1 241.8 385.1C247.4 385.1 251.7 388.9 251.7 394.7C251.7 400.4 247.4 404.5 241.8 404.5C236.2 404.5 231.9 400.4 231.9 394.7Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.7 394.7C254.7 388.9 259 385.1 264.6 385.1C270.2 385.1 274.5 388.9 274.5 394.7C274.5 400.4 270.2 404.5 264.6 404.5C259 404.5 254.7 400.4 254.7 394.7Z",
    fill: "#CFF8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.8 240.5C739.8 240.5 683.1 276.2 683.1 320.2C683.1 344.7 700.7 366.6 728.3 381.3L717.4 428.5L755.8 392.4C772.2 397.3 790.5 400 809.8 400C879.8 400 936.5 364.3 936.5 320.3C936.5 276.3 879.8 240.5 809.8 240.5Z",
    fill: "#006184"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.3 288.4C726.3 286.5 727.8 285 729.7 285C731.6 285 733.1 286.5 733.1 288.4C733.1 290.3 731.6 291.8 729.7 291.8C727.8 291.8 726.3 290.3 726.3 288.4Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.6 288.4C739.6 286.5 741.1 285 743 285C744.9 285 746.4 286.5 746.4 288.4C746.4 290.3 744.9 291.8 743 291.8C741.2 291.8 739.6 290.3 739.6 288.4Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753 288.4C753 286.5 754.501 285 756.401 285C758.301 285 759.8 286.5 759.8 288.4C759.8 290.3 758.301 291.8 756.401 291.8C754.501 291.8 753 290.3 753 288.4Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.3 288.4C766.3 286.5 767.8 285 769.7 285C771.6 285 773.1 286.5 773.1 288.4C773.1 290.3 771.6 291.8 769.7 291.8C767.9 291.8 766.3 290.3 766.3 288.4Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.7 288.4C779.7 286.5 781.2 285 783.1 285C785 285 786.5 286.5 786.5 288.4C786.5 290.3 785 291.8 783.1 291.8C781.2 291.8 779.7 290.3 779.7 288.4Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793 288.4C793 286.5 794.501 285 796.401 285C798.301 285 799.8 286.5 799.8 288.4C799.8 290.3 798.301 291.8 796.401 291.8C794.601 291.8 793 290.3 793 288.4Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.4 288.4C806.4 286.5 807.9 285 809.8 285C811.7 285 813.2 286.5 813.2 288.4C813.2 290.3 811.7 291.8 809.8 291.8C807.9 291.8 806.4 290.3 806.4 288.4Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.8 288.4C819.8 286.5 821.3 285 823.2 285C825.1 285 826.6 286.5 826.6 288.4C826.6 290.3 825.1 291.8 823.2 291.8C821.3 291.8 819.8 290.3 819.8 288.4Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.1 288.4C833.1 286.5 834.6 285 836.5 285C838.4 285 839.9 286.5 839.9 288.4C839.9 290.3 838.4 291.8 836.5 291.8C834.7 291.8 833.1 290.3 833.1 288.4Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.5 288.4C846.5 286.5 848.001 285 849.901 285C851.801 285 853.3 286.5 853.3 288.4C853.3 290.3 851.801 291.8 849.901 291.8C848.001 291.8 846.5 290.3 846.5 288.4Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859.8 288.4C859.8 286.5 861.3 285 863.2 285C865.1 285 866.6 286.5 866.6 288.4C866.6 290.3 865.1 291.8 863.2 291.8C861.4 291.8 859.8 290.3 859.8 288.4Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M873.2 288.4C873.2 286.5 874.7 285 876.6 285C878.5 285 880 286.5 880 288.4C880 290.3 878.5 291.8 876.6 291.8C874.7 291.8 873.2 290.3 873.2 288.4Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.5 288.4C886.5 286.5 888.001 285 889.901 285C891.801 285 893.3 286.5 893.3 288.4C893.3 290.3 891.801 291.8 889.901 291.8C888.101 291.8 886.5 290.3 886.5 288.4Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.3 302.4C726.3 300.5 727.8 299 729.7 299C731.6 299 733.1 300.5 733.1 302.4C733.1 304.3 731.6 305.8 729.7 305.8C727.8 305.9 726.3 304.3 726.3 302.4Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M739.6 302.4C739.6 300.5 741.1 299 743 299C744.9 299 746.4 300.5 746.4 302.4C746.4 304.3 744.9 305.8 743 305.8C741.2 305.9 739.6 304.3 739.6 302.4Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753 302.4C753 300.5 754.501 299 756.401 299C758.301 299 759.8 300.5 759.8 302.4C759.8 304.3 758.301 305.8 756.401 305.8C754.501 305.9 753 304.3 753 302.4Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.3 302.4C766.3 300.5 767.8 299 769.7 299C771.6 299 773.1 300.5 773.1 302.4C773.1 304.3 771.6 305.8 769.7 305.8C767.9 305.9 766.3 304.3 766.3 302.4Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.7 302.4C779.7 300.5 781.2 299 783.1 299C785 299 786.5 300.5 786.5 302.4C786.5 304.3 785 305.8 783.1 305.8C781.2 305.9 779.7 304.3 779.7 302.4Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M793 302.4C793 300.5 794.501 299 796.401 299C798.301 299 799.8 300.5 799.8 302.4C799.8 304.3 798.301 305.8 796.401 305.8C794.601 305.9 793 304.3 793 302.4Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.4 302.4C806.4 300.5 807.9 299 809.8 299C811.7 299 813.2 300.5 813.2 302.4C813.2 304.3 811.7 305.8 809.8 305.8C807.9 305.9 806.4 304.3 806.4 302.4Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M819.8 302.4C819.8 300.5 821.3 299 823.2 299C825.1 299 826.6 300.5 826.6 302.4C826.6 304.3 825.1 305.8 823.2 305.8C821.3 305.9 819.8 304.3 819.8 302.4Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M833.1 302.4C833.1 300.5 834.6 299 836.5 299C838.4 299 839.9 300.5 839.9 302.4C839.9 304.3 838.4 305.8 836.5 305.8C834.7 305.9 833.1 304.3 833.1 302.4Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.5 302.4C846.5 300.5 848.001 299 849.901 299C851.801 299 853.3 300.5 853.3 302.4C853.3 304.3 851.801 305.8 849.901 305.8C848.001 305.9 846.5 304.3 846.5 302.4Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859.8 302.4C859.8 300.5 861.3 299 863.2 299C865.1 299 866.6 300.5 866.6 302.4C866.6 304.3 865.1 305.8 863.2 305.8C861.4 305.9 859.8 304.3 859.8 302.4Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M873.2 302.4C873.2 300.5 874.7 299 876.6 299C878.5 299 880 300.5 880 302.4C880 304.3 878.5 305.8 876.6 305.8C874.7 305.9 873.2 304.3 873.2 302.4Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.5 302.4C886.5 300.5 888.001 299 889.901 299C891.801 299 893.3 300.5 893.3 302.4C893.3 304.3 891.801 305.8 889.901 305.8C888.101 305.9 886.5 304.3 886.5 302.4Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.3 316.4C726.3 314.5 727.8 313 729.7 313C731.6 313 733.1 314.5 733.1 316.4C733.1 318.3 731.6 319.8 729.7 319.8C727.8 319.9 726.3 318.3 726.3 316.4Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.1 319.8C744.978 319.8 746.5 318.278 746.5 316.4C746.5 314.522 744.978 313 743.1 313C741.222 313 739.7 314.522 739.7 316.4C739.7 318.278 741.222 319.8 743.1 319.8Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.401 319.8C758.278 319.8 759.8 318.278 759.8 316.4C759.8 314.522 758.278 313 756.401 313C754.523 313 753 314.522 753 316.4C753 318.278 754.523 319.8 756.401 319.8Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.3 316.4C766.3 314.5 767.8 313 769.7 313C771.6 313 773.1 314.5 773.1 316.4C773.1 318.3 771.6 319.8 769.7 319.8C767.9 319.9 766.3 318.3 766.3 316.4Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.1 319.8C784.978 319.8 786.5 318.278 786.5 316.4C786.5 314.522 784.978 313 783.1 313C781.222 313 779.7 314.522 779.7 316.4C779.7 318.278 781.222 319.8 783.1 319.8Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.5 319.8C798.378 319.8 799.9 318.278 799.9 316.4C799.9 314.522 798.378 313 796.5 313C794.622 313 793.1 314.522 793.1 316.4C793.1 318.278 794.622 319.8 796.5 319.8Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.4 316.4C806.4 314.5 807.9 313 809.8 313C811.7 313 813.2 314.5 813.2 316.4C813.2 318.3 811.7 319.8 809.8 319.8C807.9 319.9 806.4 318.3 806.4 316.4Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.2 319.8C825.078 319.8 826.6 318.278 826.6 316.4C826.6 314.522 825.078 313 823.2 313C821.323 313 819.8 314.522 819.8 316.4C819.8 318.278 821.323 319.8 823.2 319.8Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.6 319.8C838.478 319.8 840 318.278 840 316.4C840 314.522 838.478 313 836.6 313C834.722 313 833.2 314.522 833.2 316.4C833.2 318.278 834.722 319.8 836.6 319.8Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.5 316.4C846.5 314.5 848.001 313 849.901 313C851.801 313 853.3 314.5 853.3 316.4C853.3 318.3 851.801 319.8 849.901 319.8C848.001 319.9 846.5 318.3 846.5 316.4Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859.8 316.4C859.8 314.5 861.3 313 863.2 313C865.1 313 866.6 314.5 866.6 316.4C866.6 318.3 865.1 319.8 863.2 319.8C861.4 319.9 859.8 318.3 859.8 316.4Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.6 319.8C878.478 319.8 880 318.278 880 316.4C880 314.522 878.478 313 876.6 313C874.722 313 873.2 314.522 873.2 316.4C873.2 318.278 874.722 319.8 876.6 319.8Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.5 316.4C886.5 314.5 888.001 313 889.901 313C891.801 313 893.3 314.5 893.3 316.4C893.3 318.3 891.801 319.8 889.901 319.8C888.101 319.9 886.5 318.3 886.5 316.4Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.3 330.5C726.3 328.6 727.8 327.1 729.7 327.1C731.6 327.1 733.1 328.6 733.1 330.5C733.1 332.4 731.6 333.9 729.7 333.9C727.8 333.9 726.3 332.4 726.3 330.5Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.1 333.9C744.978 333.9 746.5 332.378 746.5 330.5C746.5 328.622 744.978 327.1 743.1 327.1C741.222 327.1 739.7 328.622 739.7 330.5C739.7 332.378 741.222 333.9 743.1 333.9Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.401 333.9C758.278 333.9 759.8 332.378 759.8 330.5C759.8 328.622 758.278 327.1 756.401 327.1C754.523 327.1 753 328.622 753 330.5C753 332.378 754.523 333.9 756.401 333.9Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.3 330.5C766.3 328.6 767.8 327.1 769.7 327.1C771.6 327.1 773.1 328.6 773.1 330.5C773.1 332.4 771.6 333.9 769.7 333.9C767.9 333.9 766.3 332.4 766.3 330.5Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.1 333.9C784.978 333.9 786.5 332.378 786.5 330.5C786.5 328.622 784.978 327.1 783.1 327.1C781.222 327.1 779.7 328.622 779.7 330.5C779.7 332.378 781.222 333.9 783.1 333.9Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.5 333.9C798.378 333.9 799.9 332.378 799.9 330.5C799.9 328.622 798.378 327.1 796.5 327.1C794.622 327.1 793.1 328.622 793.1 330.5C793.1 332.378 794.622 333.9 796.5 333.9Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.4 330.5C806.4 328.6 807.9 327.1 809.8 327.1C811.7 327.1 813.2 328.6 813.2 330.5C813.2 332.4 811.7 333.9 809.8 333.9C807.9 333.9 806.4 332.4 806.4 330.5Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.2 333.9C825.078 333.9 826.6 332.378 826.6 330.5C826.6 328.622 825.078 327.1 823.2 327.1C821.323 327.1 819.8 328.622 819.8 330.5C819.8 332.378 821.323 333.9 823.2 333.9Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.972 330.926C840.254 329.07 838.978 327.336 837.121 327.055C835.264 326.773 833.531 328.049 833.249 329.906C832.967 331.762 834.244 333.496 836.1 333.778C837.957 334.06 839.69 332.783 839.972 330.926Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.5 330.5C846.5 328.6 848.001 327.1 849.901 327.1C851.801 327.1 853.3 328.6 853.3 330.5C853.3 332.4 851.801 333.9 849.901 333.9C848.001 333.9 846.5 332.4 846.5 330.5Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859.8 330.5C859.8 328.6 861.3 327.1 863.2 327.1C865.1 327.1 866.6 328.6 866.6 330.5C866.6 332.4 865.1 333.9 863.2 333.9C861.4 333.9 859.8 332.4 859.8 330.5Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.6 333.9C878.478 333.9 880 332.378 880 330.5C880 328.622 878.478 327.1 876.6 327.1C874.722 327.1 873.2 328.622 873.2 330.5C873.2 332.378 874.722 333.9 876.6 333.9Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.5 330.5C886.5 328.6 888.001 327.1 889.901 327.1C891.801 327.1 893.3 328.6 893.3 330.5C893.3 332.4 891.801 333.9 889.901 333.9C888.101 333.9 886.5 332.4 886.5 330.5Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.3 344.5C726.3 342.6 727.8 341.1 729.7 341.1C731.6 341.1 733.1 342.6 733.1 344.5C733.1 346.4 731.6 347.9 729.7 347.9C727.8 347.9 726.3 346.4 726.3 344.5Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.1 347.9C744.978 347.9 746.5 346.378 746.5 344.5C746.5 342.622 744.978 341.1 743.1 341.1C741.222 341.1 739.7 342.622 739.7 344.5C739.7 346.378 741.222 347.9 743.1 347.9Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.401 347.9C758.278 347.9 759.8 346.378 759.8 344.5C759.8 342.622 758.278 341.1 756.401 341.1C754.523 341.1 753 342.622 753 344.5C753 346.378 754.523 347.9 756.401 347.9Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.3 344.5C766.3 342.6 767.8 341.1 769.7 341.1C771.6 341.1 773.1 342.6 773.1 344.5C773.1 346.4 771.6 347.9 769.7 347.9C767.9 347.9 766.3 346.4 766.3 344.5Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.1 347.9C784.978 347.9 786.5 346.378 786.5 344.5C786.5 342.622 784.978 341.1 783.1 341.1C781.222 341.1 779.7 342.622 779.7 344.5C779.7 346.378 781.222 347.9 783.1 347.9Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.5 347.9C798.378 347.9 799.9 346.378 799.9 344.5C799.9 342.622 798.378 341.1 796.5 341.1C794.622 341.1 793.1 342.622 793.1 344.5C793.1 346.378 794.622 347.9 796.5 347.9Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M806.4 344.5C806.4 342.6 807.9 341.1 809.8 341.1C811.7 341.1 813.2 342.6 813.2 344.5C813.2 346.4 811.7 347.9 809.8 347.9C807.9 347.9 806.4 346.4 806.4 344.5Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.2 347.9C825.078 347.9 826.6 346.378 826.6 344.5C826.6 342.622 825.078 341.1 823.2 341.1C821.323 341.1 819.8 342.622 819.8 344.5C819.8 346.378 821.323 347.9 823.2 347.9Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M839.916 344.943C840.185 343.085 838.896 341.36 837.038 341.091C835.179 340.823 833.455 342.111 833.186 343.97C832.918 345.828 834.206 347.553 836.065 347.821C837.923 348.09 839.647 346.801 839.916 344.943Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.5 344.5C846.5 342.6 848.001 341.1 849.901 341.1C851.801 341.1 853.3 342.6 853.3 344.5C853.3 346.4 851.801 347.9 849.901 347.9C848.001 347.9 846.5 346.4 846.5 344.5Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859.8 344.5C859.8 342.6 861.3 341.1 863.2 341.1C865.1 341.1 866.6 342.6 866.6 344.5C866.6 346.4 865.1 347.9 863.2 347.9C861.4 347.9 859.8 346.4 859.8 344.5Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.6 347.9C878.478 347.9 880 346.378 880 344.5C880 342.622 878.478 341.1 876.6 341.1C874.722 341.1 873.2 342.622 873.2 344.5C873.2 346.378 874.722 347.9 876.6 347.9Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M886.5 344.5C886.5 342.6 888.001 341.1 889.901 341.1C891.801 341.1 893.3 342.6 893.3 344.5C893.3 346.4 891.801 347.9 889.901 347.9C888.101 347.9 886.5 346.4 886.5 344.5Z",
    fill: "#01B6D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.6 234.2H493.7C488.2 234.2 483.8 229.8 483.8 224.3C483.8 218.8 488.2 214.4 493.7 214.4H613.6C619.1 214.4 623.5 218.8 623.5 224.3C623.5 229.7 619.1 234.2 613.6 234.2Z",
    fill: "#3FCDE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.6 267.1H493.7C488.2 267.1 483.8 262.7 483.8 257.2C483.8 251.7 488.2 247.3 493.7 247.3H613.6C619.1 247.3 623.5 251.7 623.5 257.2C623.5 262.7 619.1 267.1 613.6 267.1Z",
    fill: "#3FCDE3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824.9 427C829.4 426.4 833 422.9 833.5 418.4C833.5 418.3 833.6 418.3 833.7 418.4C834.3 422.9 837.8 426.5 842.3 427C842.4 427 842.4 427.1 842.3 427.2C837.8 427.8 834.2 431.3 833.7 435.8C833.7 435.9 833.6 435.9 833.5 435.8C832.9 431.3 829.4 427.7 824.9 427.2C824.8 427.2 824.8 427.1 824.9 427Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.4 191.2C543.9 190.6 547.5 187.1 548 182.6C548 182.5 548.1 182.5 548.2 182.6C548.8 187.1 552.3 190.7 556.8 191.2C556.9 191.2 556.9 191.3 556.8 191.4C552.3 192 548.7 195.5 548.2 200C548.2 200.1 548.1 200.1 548 200C547.4 195.5 543.9 191.9 539.4 191.4C539.3 191.3 539.3 191.2 539.4 191.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.075 488.6C260.575 488 264.175 484.5 264.675 480C264.675 479.9 264.775 479.9 264.875 480C265.475 484.5 268.975 488.1 273.475 488.6C273.575 488.6 273.575 488.7 273.475 488.8C268.975 489.4 265.375 492.9 264.875 497.4C264.875 497.5 264.775 497.5 264.675 497.4C264.075 492.9 260.575 489.3 256.075 488.8C255.975 488.8 255.975 488.6 256.075 488.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M853.2 413C856.1 412.5 858.5 410.2 858.9 407.3C858.9 407.2 859 407.2 859.1 407.3C859.6 410.2 861.9 412.6 864.8 413C864.9 413 864.9 413.1 864.8 413.2C861.9 413.7 859.5 416 859.1 418.9C859.1 419 859 419 858.9 418.9C858.4 416 856.1 413.6 853.2 413.2C853.1 413.2 853.1 413 853.2 413Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.4 176.4C571.3 175.9 573.7 173.6 574.1 170.7C574.1 170.6 574.2 170.6 574.3 170.7C574.8 173.6 577.1 176 580 176.4C580.1 176.4 580.1 176.5 580 176.6C577.1 177.1 574.7 179.4 574.3 182.3C574.3 182.4 574.2 182.4 574.1 182.3C573.6 179.4 571.3 177 568.4 176.6C568.3 176.5 568.3 176.4 568.4 176.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.075 504.3C284.975 503.8 287.375 501.5 287.775 498.6C287.775 498.5 287.875 498.5 287.975 498.6C288.475 501.5 290.775 503.9 293.675 504.3C293.775 504.3 293.775 504.4 293.675 504.5C290.775 505 288.375 507.3 287.975 510.2C287.975 510.3 287.875 510.3 287.775 510.2C287.275 507.3 284.975 504.9 282.075 504.5C281.975 504.5 281.975 504.3 282.075 504.3Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.6 230.2C753.5 229.7 755.9 227.4 756.3 224.5C756.3 224.4 756.4 224.4 756.5 224.5C757 227.4 759.3 229.8 762.2 230.2C762.3 230.2 762.3 230.3 762.2 230.4C759.3 230.9 756.9 233.2 756.5 236.1C756.5 236.2 756.4 236.2 756.3 236.1C755.8 233.2 753.5 230.8 750.6 230.4C750.5 230.3 750.5 230.2 750.6 230.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.2 335.3C649.1 334.8 651.5 332.5 651.9 329.6C651.9 329.5 652 329.5 652.1 329.6C652.6 332.5 654.9 334.9 657.8 335.3C657.9 335.3 657.9 335.4 657.8 335.5C654.9 336 652.5 338.3 652.1 341.2C652.1 341.3 652 341.3 651.9 341.2C651.4 338.3 649.1 335.9 646.2 335.5C646.1 335.4 646.1 335.3 646.2 335.3Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_7"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 628,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlide5);
export default __webpack_public_path__ + "static/media/slide5.768b8d63bb7698a3853457ea91122382.svg";
export { ForwardRef as ReactComponent };